import React from 'react';
import { UrlSearch, UrlSearchProvider } from '../../../data-catalog-shared';

export type LensSubplaceParams = Readonly<{
  urlSearchValue: string;
}>;

export type DatasourceSubplaceParamsProviderProps = {
  readonly children: (params: LensSubplaceParams) => React.ReactNode;
};

export class LensSubplaceParamsProvider extends React.Component<DatasourceSubplaceParamsProviderProps> {

  public override render() {
    return (
      <UrlSearchProvider>
        {urlSearch =>
          <LensSubplaceParamsProviderInternal urlSearch={urlSearch}>
            {this.props.children}
          </LensSubplaceParamsProviderInternal>
        }
      </UrlSearchProvider>
    );
  }

}

type LensSubplaceParamsProviderInternalProps = {
  readonly urlSearch: UrlSearch;
  readonly children: (params: LensSubplaceParams) => React.ReactNode;
};

class LensSubplaceParamsProviderInternal extends React.Component<LensSubplaceParamsProviderInternalProps> {

  public override render() {
    return this.props.children({
      urlSearchValue: this.props.urlSearch.value,
    });
  }
}
